import React from 'react';
import { Accordion, Col, Row } from 'react-bootstrap-5';
import Ownership from '../../call_list/owners/ownership';
import OwnerNameDisplay from './owner-name-display';
import type { Ownerships } from 'bundles/connect/types';

type Props = {
  activeKey?: string;
  owners: Ownerships[];
  setActiveKey: (key: string) => void;
}

export default function AccordionOwnerList({ activeKey, owners, setActiveKey }: Props) {
  return (
    <Row>
      <Accordion activeKey={activeKey} className="pb-2" onSelect={setActiveKey}>
        {owners.map(owner => (
          <Accordion.Item eventKey={String(owner.id)} key={owner.id}>
            <Accordion.Header>
              <Row className="align-items-center w-100">
                <Col>
                  <OwnerNameDisplay owner={owner} />
                </Col>
              </Row>
            </Accordion.Header>
            <Accordion.Body>
              <Ownership owner={owner} showOwnerName={false} />
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </Row>
  );
}
